module.exports = __webpack_public_path__ + "static/img/img_logo.a825d25f.png";